import { render, staticRenderFns } from "./MoleculeContentEditorModalImageExtensionError.vue?vue&type=template&id=52826149"
import script from "./MoleculeContentEditorModalImageExtensionError.vue?vue&type=script&lang=js"
export * from "./MoleculeContentEditorModalImageExtensionError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports